export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="font-heading text-3xl md:text-4xl text-foreground-950 mb-3">关于我们</h2>
            <p className="text-sm md:text-base text-foreground-500">
              了解51吃瓜网入口的使命与愿景
            </p>
          </div>

          <div className="bg-background-50 rounded-lg p-6 md:p-10">
            <div className="space-y-5">
              <div>
                <h3 className="font-heading text-lg md:text-xl text-foreground-900 mb-3">我们是谁</h3>
                <p className="text-sm md:text-base text-foreground-500 leading-relaxed">
                  51吃瓜网入口成立于2024年，致力于打造中文互联网领先的吃瓜内容聚合导航平台。我们聚合全网优质娱乐资讯，通过51吃瓜网站入口和51吃瓜网址为用户提供便捷的访问通道，解决51吃瓜网怎么进的核心需求，让每一位吃瓜爱好者都能快速、安全地获取最新娱乐动态。
                </p>
              </div>

              <div>
                <h3 className="font-heading text-lg md:text-xl text-foreground-900 mb-3">我们的使命</h3>
                <p className="text-sm md:text-base text-foreground-500 leading-relaxed">
                  在信息碎片化的时代，获取高质量、有组织的吃瓜内容越来越难。51吃瓜网入口以"让吃瓜更简单"为核心理念，通过51吃瓜网在线平台，将分散在各处的热门吃瓜资讯集中呈现。我们不仅提供51吃瓜最新地址和51吃瓜官方入口，更以精心策划的专题和榜单帮助用户发现最有价值的内容。
                </p>
              </div>

              <div>
                <h3 className="font-heading text-lg md:text-xl text-foreground-900 mb-3">内容承诺</h3>
                <p className="text-sm md:text-base text-foreground-500 leading-relaxed">
                  我们坚持内容聚合与导航的定位，不编造、不夸大、不传播未经证实的信息。所有展示内容均标注来源标签，用户可追溯原始出处。51吃瓜网入口的编辑团队7×24小时轮值，确保51吃瓜网入口始终提供最新、最全、最靠谱的吃瓜导航服务。
                </p>
              </div>
            </div>

            <div className="mt-8 pt-8 border-t border-background-200/70">
              <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 text-center">
                <div>
                  <div className="font-heading text-2xl md:text-3xl text-primary-500">500万+</div>
                  <div className="text-xs text-foreground-400 mt-1">月活跃用户</div>
                </div>
                <div>
                  <div className="font-heading text-2xl md:text-3xl text-primary-500">1000+</div>
                  <div className="text-xs text-foreground-400 mt-1">每日更新内容</div>
                </div>
                <div>
                  <div className="font-heading text-2xl md:text-3xl text-primary-500">15+</div>
                  <div className="text-xs text-foreground-400 mt-1">内容分类</div>
                </div>
                <div>
                  <div className="font-heading text-2xl md:text-3xl text-primary-500">99.9%</div>
                  <div className="text-xs text-foreground-400 mt-1">服务稳定性</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}